var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "home" },
    [
      _vm._m(0),
      _vm._v(" "),
      _vm._m(1),
      _vm._v(" "),
      _c("div", { staticClass: "appstore clear" }, [
        _vm.download
          ? _c("div", { staticClass: "download-guide" }, [
              _c("img", { attrs: { src: "/public/download_guide.png" } }),
            ])
          : _vm._e(),
        _vm._v(" "),
        _c("div", { staticClass: "btn-download-group" }, [
          _vm.ios
            ? _c(
                "a",
                {
                  attrs: { href: "this.$config.iOSAPPUrl" },
                  on: { click: _vm.handleEvent },
                },
                [_vm._v("Download the app")]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.android
            ? _c(
                "a",
                {
                  attrs: { href: "this.$config.androidAPPUrl" },
                  on: { click: _vm.handleEvent },
                },
                [_vm._v("Download the app")]
              )
            : _vm._e(),
        ]),
      ]),
      _vm._v(" "),
      _c("Footer"),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", [
      _c("img", {
        staticClass: "logo",
        attrs: { src: "/public/lmk_text@2x.png" },
      }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", [
      _c("img", {
        staticClass: "slogan",
        attrs: { src: "/public/slogan.png" },
      }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }


// WEBPACK FOOTER //
// src/components/mobile/HomeAd.vue